<template>
  <p v-show="list.length > 0" class="heading-h5 m-b--24">Recommended for you</p>
  <div class="routeplanner__recommended">
    <deals-block v-show="list.length > 0" :isRouteplanner="true">
      <template #content="{ setDestinationData }">
        <ul v-show="list.length !== 0">
          <li v-for="item in list" :key="item?.locationKey">
            <recommendation-button
              :locationKey="item?.deal.toCity.trim().toLocaleLowerCase()"
            >
              <button
                class="
                  link
                  cta cta--simple-content
                  hover-shadow hover-enlarge-image
                "
                @click="
                  setDestinationData &&
                    setDestinationData({
                      dealId: '01',
                      fromDestinationCode: item.deal.fromIata,
                      toDestinationCode: item.deal.toIata,
                      fromDestination: item.deal.fromCity,
                      toDestination: item.deal.toCity,
                      currencyCode: item.deal.currencyCode,
                      tripType: item.deal.tripType,
                      tripClass: item.deal.tripClass,
                      tripCost: item.deal.tripCost,
                      travelDates: `${item.deal.departureDate} to ${item.deal.returnDate}`,
                      tripDuration: item.deal.tripDuration,
                      farePromotionDuration: `Until ${item.deal.promotionEndDate}`,
                      mobileImage: item.thumbnailImage.imageSizeUrls.Large,
                      desktopImage: `${baseUrl}${item.bannerImage.imageSizeUrls.Large}`,
                      fareConditionContent: item.fareConditionContent,
                    });
                  createVisaItinery(
                    item.deal.toIata,
                    item.deal.fromIata,
                    item.deal.departureDate,
                    item.deal.returnDate,
                  );
                "
              >
                <span class="sr-only">Select offer</span>
                <div class="cta__simple-content-image-holder">
                  <picture>
                    <source
                      media="(min-width: 1200px)"
                      :srcset="`${baseUrl}${item.thumbnailImage.imageSizeUrls.Large}`"
                      width="950"
                      height="500"
                    />
                    <source
                      media="(min-width: 768px)"
                      :srcset="`${baseUrl}${item.thumbnailImage.imageSizeUrls.Large}`"
                      width="800"
                      height="420"
                    />
                    <source
                      media="(min-width: 414px)"
                      :srcset="`${baseUrl}${item.thumbnailImage.imageSizeUrls.Large}`"
                      width="382"
                      height="200"
                    />
                    <img
                      :src="`${baseUrl}${item.thumbnailImage.imageSizeUrls.Large}`"
                      :alt="item.thumbnailImage.altText"
                      loading="lazy"
                      width="382"
                      height="200"
                    />
                  </picture>
                </div>
                <div class="cta__simple-content">
                  <p class="paragraph-lead font--CabritoFlare m-b--0">
                    {{ item.deal.toCity }}
                  </p>

                  <p class="paragraph-note m-b--0 text-KQ-Grey2">
                    <span>{{ item.deal.departureDate }}</span> -
                    <span>{{ item.deal.returnDate }}</span>
                  </p>
                  <p class="paragraph-note text--bold m-b--0 text-KQ-Grey1">
                    From <span> {{ currencyCode }} </span>&nbsp;
                    <span class="paragraph-body text--bold">
                      {{ item.deal.tripCost }}</span
                    >
                  </p>
                </div>
              </button>
            </recommendation-button>
          </li>
        </ul>
      </template>
      <template #dealsmodal="dealsmodalprops">
        <slot name="dealsmodal" v-bind="dealsmodalprops"></slot>
      </template>
      <template #visamodal="visamodalprops">
        <slot
          name="visamodal"
          v-bind="visamodalprops"
          :itineraries="itineraries"
        ></slot>
      </template>
    </deals-block>

    <p v-if="!dealsLoading && list.length === 0">
      No recommended destinations found.
      <span class="display-md--none">
        Try adjusting your:
        <button
          class="button button--text button--text-inline"
          :onClick="
            () => {
              openSheetHandler();
            }
          "
        >
          FILTERS
        </button>
      </span>
    </p>

    <div class="routeplanner__loader">
      <div v-if="dealsLoading" class="loader"></div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from 'vue';
import { default as RecommendationButton } from './recommendation-button.vue';
import { formatDateShort } from '../../lib/dateUtils';
import DealsBlock from '../DealsBlock/DealsBlock.vue';
import { getBaseUrlContentApi } from '../../services/api/getBaseUrl';

const props = defineProps({
  deals: {
    type: Array,
    default: () => [],
  },
  dealsLoading: {
    type: Boolean,
    default: false,
  },
  formValues: {
    type: Object,
    default: () => {
      return {};
    },
  },
  currencyCookie: {
    type: String,
    default: 'kq_currency',
  },
  destination: {
    type: Object,
    default: null,
  },
  allAirports: {
    type: Array,
    default: () => [],
  },
});
const itineraries = ref([{}, {}]);
const baseUrl = getBaseUrlContentApi();

const currencyCode = computed(() => {
  return props.deals?.[0]?.deal?.currencyCode || 'KES';
});

const list = computed(() => {
  if (
    props.departLocation === '' ||
    props.dealsLoading ||
    props.deals.length === 0
  ) {
    return [];
  }

  return (
    props.deals?.map((item) => {
      let deal = { ...item.deal };
      if (deal.currencyDecimalPlaces !== 0) {
        let priceString = deal.tripCost.toString();
        let modifiedPriceString =
          priceString.slice(0, -deal.currencyDecimalPlaces) +
          '.' +
          priceString.slice(-deal.currencyDecimalPlaces);
        deal.tripCost = parseFloat(modifiedPriceString).toFixed(
          deal.currencyDecimalPlaces,
        );
      }

      deal.departureDate = formatDateShort(new Date(deal.departureDate));
      deal.returnDate = formatDateShort(new Date(deal.returnDate));
      deal.promotionEndDate = formatDateShort(new Date(deal.promotionEndDate));
      return {
        ...item,
        deal,
      };
    }) ?? []
  );
});

const findAirport = (iata) => {
  return props.allAirports.find((obj) => obj.locIATA === iata);
};

const createVisaItinery = (to, from, departureDate, returnDate) => {
  const fromAirport = findAirport(from);
  const toAirport = findAirport(to);
  itineraries.value = [
    {
      fromAirport: fromAirport,
      toAirport: toAirport,
      departureDate: departureDate,
    },
    {
      fromAirport: toAirport,
      toAirport: fromAirport,
      departureDate: returnDate,
    },
  ];
};

</script>
